export const EntitlementLimitPopUpEvent = "Entitlement Limit Pop Up";
